module.exports = __webpack_public_path__ + "img/2.c54c8f30.jpg";